import React, { useEffect, useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import WebTopBar from '../components/WebTopBar.js';
import { DCard, BtnGold } from '../components/MarketplaceAtoms.js';
import { fetchPartnerTicketSalesEligibility } from '../../lib/partnerTicketSales.js';

export default function PageTiendaEntradas({ onBack, onNavigate, user }) {
  const [eligibility, setEligibility] = useState({ loading: true, eligible: false, reason: '' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!user?.id) {
        if (!cancelled) setEligibility({ loading: false, eligible: false, reason: 'Inicia sesión como partner.' });
        return;
      }
      const el = await fetchPartnerTicketSalesEligibility(user.id);
      if (!cancelled) {
        setEligibility({ loading: false, eligible: !!el.eligible, reason: el.reason || '' });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  return (
    <div style={{ background: C.dark, minHeight: '100vh', color: '#fff' }}>
      <WebTopBar
        onBack={onBack}
        title="Panel Partner — Entradas"
        mini
        dark
        user={user}
        onNavigate={onNavigate}
        onSignOut={onBack}
      />
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 20px 60px' }}>
        {eligibility.loading ? (
          <DCard style={{ padding: 28, textAlign: 'center' }}>
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)' }}>Comprobando acceso…</div>
          </DCard>
        ) : eligibility.eligible ? (
          <DCard
            style={{
              padding: 28,
              background: 'rgba(200,168,75,0.04)',
              borderColor: 'rgba(200,168,75,0.18)',
            }}
          >
            <div style={{ fontSize: 15, fontWeight: 700, color: C.gold, marginBottom: 10 }}>Venta de entradas activa</div>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.55, margin: '0 0 16px' }}>
              Publica eventos en Comunidad con tu enlace de ticketera. DreamVinyl verificará la URL antes de mostrar el botón
              «Comprar entradas» en el feed.
            </p>
            <BtnGold type="button" style={{ width: 'auto', minWidth: 200 }} onClick={() => onNavigate?.('comunidad')}>
              Ir a Comunidad
            </BtnGold>
          </DCard>
        ) : (
          <DCard
            style={{
              padding: 28,
              textAlign: 'center',
              background: 'rgba(200,168,75,0.04)',
              borderColor: 'rgba(200,168,75,0.18)',
            }}
          >
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', marginBottom: 8 }}>Entradas no disponibles</div>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.42)', lineHeight: 1.55, margin: 0 }}>
              {eligibility.reason ||
                'La venta de entradas está reservada a partners verificados con suscripción activa. Contacta con DreamVinyl si crees que deberías tener acceso.'}
            </p>
          </DCard>
        )}
      </div>
    </div>
  );
}
